// Medição de visitas com Google Analytics 4 (ID G-B4Z317RZQX, configurado em public/index.html).
//
// Tudo aqui é "à prova de falhas": se o Google Analytics estiver bloqueado (anunciantes,
// extensões de privacidade) ou não carregar, nada disso quebra o site.

// Nomes das páginas como aparecem nos relatórios do Analytics.
// (O título da aba do navegador é igual em todas as páginas, então enviamos um nome próprio.)
const PAGE_TITLES = {
  '/': 'Início',
  '/suites': 'Suítes',
  '/historia': 'História',
  '/experiencias': 'Experiências',
  '/galeria': 'Galeria',
  '/contato': 'Contato',
  '/guia-hospede': 'Guia do Hóspede',
};

const pageTitleFor = (path) => {
  const pathname = path.split('?')[0].replace(/\/+$/, '') || '/';
  if (PAGE_TITLES[pathname]) return PAGE_TITLES[pathname];
  if (pathname.startsWith('/suite/')) return `Suíte - ${pathname.split('/')[2]}`;
  return pathname;
};

// Idioma escolhido pelo visitante no site (pt, en ou es).
const currentSiteLanguage = () => {
  try {
    return window.localStorage.getItem('language') || 'pt';
  } catch (e) {
    return 'pt';
  }
};

// Envia um evento ao Google Analytics. "beacon" garante que o envio não se perde
// quando o clique leva o visitante para outra página (por exemplo, o motor de reservas).
export const trackEvent = (name, params = {}) => {
  try {
    if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
      window.gtag('event', name, { transport_type: 'beacon', ...params });
    }
  } catch (e) {
    /* a medição nunca deve atrapalhar o site */
  }
};

// Registra uma página visitada (chamado a cada troca de página pelo PageViewTracker).
export const trackPageView = (path) => {
  try {
    trackEvent('page_view', {
      page_path: path,
      page_location: `${window.location.origin}${path}`,
      page_title: pageTitleFor(path),
      site_language: currentSiteLanguage(),
    });
  } catch (e) {
    /* ignora */
  }
};

// Descobre se um link é um dos que queremos contar.
const eventNameForLink = (href) => {
  if (!href) return null;
  if (href.includes('reserva.html')) return 'reservar_click';
  if (/^https?:\/\/(wa\.me|api\.whatsapp\.com)\//.test(href)) return 'whatsapp_click';
  if (href.startsWith('tel:')) return 'telefone_click';
  if (href.startsWith('mailto:')) return 'email_click';
  return null;
};

// Conta os cliques em links de Reservar, WhatsApp, telefone e e-mail em qualquer página,
// sem precisar alterar cada botão. Devolve a função que desliga a contagem.
export const startClickTracking = () => {
  const onClick = (event) => {
    try {
      const target = event.target;
      const link = target && target.closest ? target.closest('a[href]') : null;
      if (!link) return;
      const href = link.getAttribute('href');
      const eventName = eventNameForLink(href);
      if (!eventName) return;
      trackEvent(eventName, {
        link_url: href.split('?')[0], // sem o texto da mensagem pré-preenchida
        link_text: (link.textContent || '').trim().slice(0, 60),
        page_path: window.location.pathname,
        site_language: currentSiteLanguage(),
      });
    } catch (e) {
      /* ignora */
    }
  };
  document.addEventListener('click', onClick);
  return () => document.removeEventListener('click', onClick);
};
